import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
